module.exports = __webpack_public_path__ + "static/media/ten-8.jpeg";